import { render, staticRenderFns } from "./recoverPass.vue?vue&type=template&id=5a4a77e8"
import script from "./recoverPass.vue?vue&type=script&lang=js"
export * from "./recoverPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports